import React from 'react';
import { observer } from 'mobx-react';

interface IAlertProps {
  show: boolean;
  type: 'success' | 'error' | 'warning';
  title?: React.ReactElement | string;
  msg?: React.ReactElement | string;
  msgClass?: string;
}

const AlertComponent = (props: IAlertProps) => {
  const { show, type, title, msg, msgClass } = props;
  const alertTitle = title ? title : type[0].toLocaleUpperCase() + type.substring(1);
  return (
    <div
      className={'usa-alert usa-alert--' + type}
      role={type === 'error' ? 'alert' : 'status'}
      hidden={!show}
      aria-atomic={false}
    >
      <div className="usa-alert__body">
        <h3 className="usa-alert__heading" aria-hidden={true}>
          {alertTitle}
        </h3>
        <div className={`usa-alert__text ${msgClass ? msgClass : ''}`}>
          <span className="usa-sr-only">{alertTitle}</span> {msg}
        </div>
      </div>
    </div>
  );
};

export const Alert = observer(AlertComponent);
